import React from 'react';
import styles from './styles.module.scss';
import PoolBalance from '../PoolBalance';
import VestingSafeInfo from '../VestingSafeInfo';
import ClaimBlock from '../ClaimBlock';
import { useTypedDispatch, useTypedSelector } from '@vestingSafe/src/redux/utils';
import { useVestingModal } from '../../VestingSafeModalProvider';
import { parseInt } from 'lodash';
import { fetchIngameBalance, fetchVestingSafe, fetchVestingSafeConfigs } from '@vestingSafe/src/redux/actions';
import { parseAmountGTHGToSystemCurrency } from '@vestingSafe/src/VestingSafe/utils';

const MainContent = () => {
  const dispatch = useTypedDispatch();
  const {
    modal
  } = useVestingModal();
  const VestingConfig = useTypedSelector(state => state.vestingSafeConfigs.data);
  const extraClaimFee = VestingConfig ? VestingConfig.secondClaimFee / 100 : 0;
  const vestingSafe = useTypedSelector(state => state.vestingSafe.data);
  const remainingInPool = vestingSafe && !!vestingSafe.amountTotal.value // Check if total amount gTHG greater than 0, if not, the pool should be zero
  ? parseInt(vestingSafe.amountTotal.value) - parseInt(vestingSafe.released.value) : 0;
  const isSmallerThanMin = parseInt((vestingSafe === null || vestingSafe === void 0 ? void 0 : vestingSafe.claimable.value) || '0') < parseInt((VestingConfig === null || VestingConfig === void 0 ? void 0 : VestingConfig.minPaid.value) || '0');
  const onFetch = React.useCallback(() => {
    dispatch(fetchVestingSafeConfigs());
    dispatch(fetchIngameBalance());
    dispatch(fetchVestingSafe());
  }, []);
  React.useEffect(() => {
    onFetch();
  }, [modal]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(PoolBalance, {
    remainingInPool: parseAmountGTHGToSystemCurrency(remainingInPool)
  }), /*#__PURE__*/React.createElement(VestingSafeInfo, {
    paidPercent: vestingSafe === null || vestingSafe === void 0 ? void 0 : vestingSafe.dailyGTHGVestingPercent,
    minPaid: VestingConfig === null || VestingConfig === void 0 ? void 0 : VestingConfig.minPaid,
    maxPaid: vestingSafe === null || vestingSafe === void 0 ? void 0 : vestingSafe.maxPaid
  }), /*#__PURE__*/React.createElement(ClaimBlock, {
    claimableAmount: vestingSafe === null || vestingSafe === void 0 ? void 0 : vestingSafe.claimable,
    secondClaimFee: extraClaimFee,
    remainingInPool: remainingInPool,
    isSmallerThanMin: isSmallerThanMin,
    fee: vestingSafe === null || vestingSafe === void 0 ? void 0 : vestingSafe.fee
  }));
};

export default MainContent;